import { FormattedHTMLMessage } from "react-intl";

import { getFieldConfigByFieldId } from "@/lib/utils/stepComponentHelpers/stepComponentHelpers";

import { type FormFieldComponentProps } from "../../../lib/types/types";
import { DateComponent } from "../../DateComponent/DateComponent";

type Props = Omit<FormFieldComponentProps, "isErrored"> & {
  locale?: string;
  /**
   * @deprecated deprecated in favor of using errorId instead
   */
  isErrored?: boolean;
  mode?: "date" | "month";
};

export const DischargeDateComponent = ({
  onChange,
  errorId,
  isErrored = !!errorId,
  value = "2000-01-01",
  disabled = false,
  locale,
  mode = "month",
  isRequired = true,
}: Props) => {
  const isFieldHidden = getFieldConfigByFieldId("dischargeDate")?.hidden;

  if (isFieldHidden) {
    return null;
  }

  return (
    <DateComponent
      mode={mode}
      value={value}
      label={<FormattedHTMLMessage id="dischargeDate" defaultMessage="Discharge date" />}
      explanation={
        <FormattedHTMLMessage
          id="verificationPurposesOnly"
          defaultMessage="Used for verification purposes only"
        />
      }
      onChange={onChange}
      fieldName="dischargeDate"
      fieldId="discharge-date"
      isErrored={isErrored}
      disabled={disabled}
      isRequired={isRequired}
      locale={locale}
      errorMsg={
        <FormattedHTMLMessage id={`errorId.${errorId}`} defaultMessage="Invalid discharge date" />
      }
    />
  );
};
